import React from 'react';

interface GreyWrapperProps {
  children: React.ReactNode;
  customStyle?: string;
}

const GreyWrapper: React.FC<GreyWrapperProps> = ({ children, customStyle }) => {
  return (
    <div className={`w-full p-[25px] bg-[#F4F4F4] rounded-[10px] ${customStyle || ''}`}>
      {children}
    </div>
  );
};

export default GreyWrapper;
